import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'E-mailbeskeder',
  labels: {
    view_full_message: 'Se hele beskeden',
    status: 'Status:',
    on: 'Til',
    off: 'Fra',
  },
  tiles: {
    sends_count: 'Sendte beskeder',
    delivery_rate: 'Leveringsrate',
    delivered_suffix: 'leveret',
    open_rate: 'Åbningsrate',
    opened_suffix: 'åbnet',
    click_rate: 'Klikrate',
    clicked_suffix: 'klikket',
    spam_report_rate: 'Spamrapporteringsrate',
    spam_reports_suffix: 'rapporter',
    unsubscribe_rate: 'Afmeldingsrate',
    unsubscribes_suffix: 'afmeldinger',
  },
  toasts: {
    failed_to_update_status: 'Status kunne ikke opdateres',
    failed_to_load_data: 'Data kunne ikke indlæses',
  },

  preview_modal: {
    title: 'Skabelonvisning',
    labels: {
      subject: 'Emne:',
      close: 'Luk',
    },
    toasts: {
      failed_to_load_data: 'Forhåndsvisningen kunne ikke indlæses',
    },
    template_data: {
      recipient_name: '&lt;Fornavn&gt;',
    },
  },
};
